import { createTheme, type PaletteMode } from '@mui/material/styles';

/** Separate palettes, not an inverted background: the brand navy is 1.6:1 on dark. */
const palettes = {
  light: {
    primary: { main: '#0e305d', light: '#1a4a8a', dark: '#091f3d', contrastText: '#fff' },
    background: { default: '#F0F2F5', paper: '#FFFFFF' },
    text: { primary: '#1C1E21', secondary: '#65676B' },
    divider: 'rgba(0, 0, 0, 0.12)',
  },
  dark: {
    primary: { main: '#7EB0E8', light: '#A7CBF2', dark: '#4A80B8', contrastText: '#08121F' },
    background: { default: '#12161C', paper: '#1A2029' },
    text: { primary: '#E6E9EC', secondary: '#A0A7B0' },
    divider: 'rgba(255, 255, 255, 0.14)',
  },
} as const;

export function buildTheme(mode: PaletteMode) {
  return createTheme({
  palette: {
    mode,
    ...palettes[mode],
    secondary: { main: '#2196F3', light: '#64B5F6', dark: '#1565C0', contrastText: '#fff' },
    error: { main: mode === 'dark' ? '#FF7A7E' : '#FA383E' },
    warning: { main: mode === 'dark' ? '#FFCB5C' : '#F7B928' },
    success: { main: mode === 'dark' ? '#6FD65A' : '#42B72A' },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '0.9375rem',
    },
    body2: {
      fontSize: '0.8125rem',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
                boxShadow: mode === 'dark' ? 'none' : '0 1px 2px rgba(0, 0, 0, 0.1)',
          ...(mode === 'dark' && { border: `1px solid ${palettes.dark.divider}` }),
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: mode === 'dark' ? 'none' : '0 1px 2px rgba(0, 0, 0, 0.1)',
          ...(mode === 'dark' && { borderBottom: `1px solid ${palettes.dark.divider}` }),
        },
      },
    },
  },
  });
}

